import { useLoaderData } from "react-router";
import { api } from "@/lib/api";
import type { GuideCard as GuideCardType, GuideTopicCard } from "@/lib/guides";
import GuidesIndexPage from "@/components/pages/GuidesIndexPage";

type Resp = { topics: GuideTopicCard[]; guides: GuideCardType[] };

// Fetched by the router before the route renders, so the page mounts already
// populated — no in-page "Loading…" swap (which caused a visible flicker).
export async function guidesLoader() {
  return api.get<Resp>("/api/guides");
}

export function Guides() {
  const data = useLoaderData() as Resp;
  return <GuidesIndexPage topics={data.topics} guides={data.guides} />;
}
